import Base from './base';

class PreferredBrokerSelector extends Base {
	get image() {
		if (!this.refs.image) {
			this.refs.image = new Image();
			this.refs.image.classList.add('image', 'image--width-medium');
			this.refs.imageContainer.appendChild(this.refs.image);
		}

		return this.refs.image;
	}

	start() {
		const { refs: { selector, share, submit } } = this;

		this.brokerOptions = [...selector.options];
		this.gtmData = JSON.parse(submit.dataset.gtmPush);

		this.on('change', selector);
		this.on('change', share);
		this.on('click', this.el);

		if (share) {
			this.setBrokerSelectorState(share.checked);
			this.toggleGtmClickTracking(share.checked);
		}

		this.setGtmPushData(selector);
		this.updateImage(selector.value);
	}

	onChange({ target }) {
		const { selector, share } = this.refs;

		if (target === selector) {
			this.updateImage(target.value);
		}

		if (target === share) {
			this.toggleGtmClickTracking(share.checked);
			this.setBrokerSelectorState(share.checked);
		}

		this.setGtmPushData(selector);
	}

	onClick({ target }) {
		if (target === this.refs.skip) {
			this.skipStep();
		}
	}

	updateImage(value) {
		const { image } = this;

		const option = this.brokerOptions.find(o => o.value === value);
		const { dataset: { iconUrl } = {} } = option;

		image.classList.toggle('is-hidden', !iconUrl);
		image.src = iconUrl;
	}

	setBrokerSelectorState(shareIsChecked) {
		this.refs.selector.disabled = !shareIsChecked;
	}

	skipStep() {
		const { share, selector } = this.refs;

		if (share) {
			share.checked = false;
			share.required = false;
		}

		selector.value = '';
		selector.required = false;

		this.updateImage('');
	}

	getGtmPushData(brokerName, action) {
		const { gtmData } = this;

		gtmData.events.broker = brokerName;
		gtmData.events.action = action;

		return JSON.stringify(gtmData);
	}

	setGtmPushData(target) {
		const { text, value } = target.options[target.selectedIndex];
		const action = value ? 'Save Preferences' : 'No Preferences';
		const broker = value ? text : '';

		this.refs.submit.dataset.gtmPush = this.getGtmPushData(broker, action);
	}

	toggleGtmClickTracking(isChecked) {
		const { submit } = this.refs;

		if (isChecked) {
			submit.dataset.gtmClick = true;

			return;
		}

		delete submit.dataset.gtmClick;
	}
}

export default PreferredBrokerSelector;
